module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/banner-mobile.1d18f595.png";